import {
  buildPosthogGuestPerson,
  buildPosthogOrderCompleted,
} from "~/core/analytics/posthogEvents";

// Compatible with the existing verified success-page GTM/Meta/Pinterest dispatcher.
// This only stages a payload: a wallet click/authorization is never a purchase.
// `person` ({guest, email, gpc}) is the wallet payer: owner decision D5b
// stages a guest buyer's email for the anonymous PostHog profile, analytics
// only and never under GPC (PostHog does not load then).
export function stageExpressPurchase(
  result,
  consent,
  storage,
  now = Date.now(),
  person = {}
) {
  const ecommerce = result.quote?.ecommerce;
  if (!ecommerce || !result.orderId)
    throw new Error("Missing order tracking context.");
  const params = new URL(result.returnUrl).searchParams;
  const orderNumber = params.get("order_number") || "";
  const orderId = String(result.orderId);
  const purchase = { ...ecommerce, transaction_id: orderNumber || orderId };
  try {
    storage.setItem("order_id", orderId);
    if (orderNumber) storage.setItem("order_number", orderNumber);
    if (!consent.analytics && !consent.marketing) {
      storage.removeItem("vf_pending_purchase");
      return;
    }
    storage.setItem(
      "vf_pending_purchase",
      JSON.stringify({
        orderId,
        orderNumber,
        ts: now,
        ga4: consent.analytics
          ? { event: "purchase", ecommerce: purchase }
          : null,
        pinterest: consent.marketing ? purchase : null,
        fbq: consent.marketing
          ? {
              content_ids: ecommerce.items.map((item) => item.item_id),
              content_name: ecommerce.items.map((item) => item.item_name),
              content_type: "product",
              value: result.quote.amount / 100,
              currency: ecommerce.currency,
            }
          : null,
        // PostHog Order Completed: revenue = the wallet's grand total
        // (quote.amount cents / 100); no order id or number.
        posthog: consent.analytics
          ? buildPosthogOrderCompleted({
              ecommerce,
              grandTotalCents: result.quote.amount,
              checkoutType: "express",
            })
          : null,
        // Never in an event property; removed with this stash.
        posthogPerson: buildPosthogGuestPerson({
          analyticsAllowed: consent.analytics === true && person?.gpc !== true,
          guest: person?.guest === true,
          email: person?.email,
        }),
      })
    );
  } catch {
    /* Storage restrictions cannot interrupt a payment. */
  }
}
